import { RouteLocationNormalized } from 'vue-router';
import { PartnerAppGate } from '@/services/partner-app-gate';
import { application } from '@/utils/plugins/di/providers';

/** Баннер — атрибут страниц филиала: /filials/:filial_id/* и ничего кроме */
const FILIAL_PATH_PREFIX = '/filials/';

const getFilialId = (to: RouteLocationNormalized): number => {
	if (!to.path.startsWith(FILIAL_PATH_PREFIX)) {
		return 0;
	}

	return +(to.params.filial_id || '');
};

/**
 * Гейт партнёрского приложения по бренду филиала (поток A, DDR-259).
 *
 * Вешается на `router.afterEach`: решение привязано к странице, на которую
 * гость реально попал, переход ничего не ждёт, а отменённая навигация не
 * оставляет баннер от филиала, который так и не открылся. Вне страниц филиала
 * гейт сбрасываем — на корзине, заказах и профиле баннера нет.
 *
 * На партнёрском домене (есть контракт) работает поток B в AppLayout, а в
 * исключённых обёртках (нативка, RahmetApp, планшет) гейт не показываем.
 */
export default (to: RouteLocationNormalized): void => {
	const filialId = getFilialId(to);

	if (!filialId) {
		PartnerAppGate.clear();
		return;
	}

	if (
		application.getCustomConfig() ||
		PartnerAppGate.isExcluded(String(to.query.source || ''))
	) {
		PartnerAppGate.clear();
		return;
	}

	// Решение Brandy подтянется в фоне: кэш по филиалу, fail-open
	void PartnerAppGate.setCurrentFilial(filialId);
};
